// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "paperRoot-2AQ8E";
var _4 = "heading-3Avsn";
var _5 = "tab-2M1O4";
var _6 = "tab_active-2ytOh";
var _7 = "tabIndicator-Tg-of";
var _8 = "fareConditionsSegmentHeading__inner-1s7nZ";
var _9 = "fareConditionsSegmentFareCode-2k0ih";
var _a = "fareConditionsContent-1lqSG";
export { _1 as "__esModule", _2 as "mobile", _3 as "paperRoot", _4 as "heading", _5 as "tab", _6 as "tab_active", _7 as "tabIndicator", _8 as "fareConditionsSegmentHeading__inner", _9 as "fareConditionsSegmentFareCode", _a as "fareConditionsContent" }
export default { "__esModule": _1, "mobile": _2, "paperRoot": _3, "heading": _4, "tab": _5, "tab_active": _6, "tabIndicator": _7, "fareConditionsSegmentHeading__inner": _8, "fareConditionsSegmentFareCode": _9, "fareConditionsContent": _a }
